import { render, staticRenderFns } from "./AreaDetails.vue?vue&type=template&id=12d845ec&scoped=true&"
import script from "./AreaDetails.vue?vue&type=script&lang=js&"
export * from "./AreaDetails.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetails.vue?vue&type=style&index=0&id=12d845ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d845ec",
  null
  
)

export default component.exports